import moment from 'moment-timezone'
import filesize from 'filesize.js'

export default {
    getRepYrStaticLov(){
        let currentYear = parseInt(new Date().getFullYear(),10);
        let startYr = currentYear - 10;
        let endYr = currentYear + 1;
        let staticYrs = [];
        /* Build year lov, plus/minus 10 of the current year */ 
        for (let i=startYr;i<=endYr;i++) {
            staticYrs.push(i);
        }
        return staticYrs;
    },
    getErrorData(errorResponse){
        /** 
         * errorResponse is error.response from
         * catch/error callback function of API calls;
         * */
        let returnData = {
            errorData : null,
            dialog : {
                title : "Whoops! Server error encountered.",
                message : ''
            } 
        };
        try {
            let errorData = null;
            if (errorResponse.data &&
                errorResponse.data.hasOwnProperty('error')) {
                /** These are 400 and 405 error thrown from PHP files */
                errorData = errorResponse.data.error;
            }
            else {
                /** For non-400/405 errors like
                 * internal server error or timeout, etc. */
                errorData = {
                    code : errorResponse.status,
                    message : errorResponse.statusText,
                    type : 'ServerError'
                }
            }
            returnData.errorData = errorData;
            returnData.dialog.message = "<p>Something went wrong and it's not likely to resolve on it's own.</p><br/><p>To contact support or inform the Admin about this issue, click <strong>Submit Error</strong>. Otherwise, click <i>Close</i>.</p><br/>"
                                       +"<p><strong>Error Details:</strong> <br/>["+errorData.type+" "+errorData.code+"] - <i>"+errorData.message+"<i> </p>";
            return returnData;
        }
        catch(errResp){
        }
        return null;
    },
    requiredConversion(){
        if (process.env.NODE_ENV=='development') {
            return false
        }
        return true
    },
    convertDate(date){
        if (this.requiredConversion()==true) {
            var offset = moment().utcOffset();
            var local = moment.utc(date).utcOffset(offset).format('YYYY-MM-DD HH:mm:ss');
            return local;
        }
        var current = moment.tz(date,'America/Los_Angeles').tz('Asia/Manila').format('YYYY-MM-DD HH:mm:ss');
        return current;
    },
    convertFileSize(val) {
        return filesize(val)
    }
}


// WEBPACK FOOTER //
// ./src/utilities/AppResourceUtil.js